/*
 * Day Picker View!!!!!!!!!!!
 * Wrapper for containing months and do all the logic
 *
 * Created by Vladimir Shishlyannikov on 24/09/2022.
 * Copyright (c) 2022 iWoo Ltd. All rights reserved.
 */

import React from 'react';
import {
  View,
  // ScrollView,
  StyleSheet,
  // NativeSyntheticEvent,
  // NativeScrollEvent
} from 'react-native';
import PropTypes from 'prop-types'; // use directly
// import clsx from 'clsx';
import Lottie from 'react-lottie';

import Button from '@material-ui/core/Button';
// import Grid from '@material-ui/core/Grid';
// import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
// import RoundedContainer from '../../RoundedContainer/RoundedContainer';

import Typography from '@material-ui/core/Typography';

import SquaresIcon from '../../../icons/SquaresIcon';
import SquaresOIcon from '../../../icons/SquaresOIcon';
import CheckBoxIcon from '../../../icons/CheckBoxIcon';
import CloseIcon from '../../../icons/Close2Icon';
import LoaderSpinnerIcon from '../../../icons/LoaderSpinnerIcon';

import { withStyles, Theme } from '@material-ui/core/styles';

import AvailabilityView from '../AvailabilityView/AvailabilityView'; // './CalendarCell';

// import { TimeSlot } from '../../../types';
// import * as dates from  '../../../utils/dates';
import * as _ from '../../../utils/_';

// import Header from '../Header/Header';
// import Month from '../Month/Month';
import { date as dateLocalizer } from '../../../utils/localizers';

import TimeTablePlaceholder from './TimeTable';

import animationData from '../../../lotties/loading-spinner';

// }
// .ap-calendar-grid .ap-cell {
//     width: 40px;
//     height: 40px;
// }
// .ap-cell.ap-state-disabled {
//     color: #999;
//     filter: alpha(opacity=7);
//     opacity: .7;
// }
// .ap-cell, .ap-head-cell {
//     border: '0';
// }
// .ap-cell {
//     color: #333;
//     border-radius: 8px;
//     cursor: pointer;
//     line-height: normal;
//     border: 1px solid transparent;
// }

const CONTAINER_GUTTER = '16px';

const styles = (theme: Theme) => ({
  container: {
    // background: theme.galleryView'Background-color',
    // position: 'relative',
    // gridArea: '1 / 1 / 2 / 3',
    'flex-grow': 1,
    'padding-top': '16px',
    'padding-bottom': '120px',
  },
  availabilityTimePickerContainer: {
    width: '100%',
    // display: 'block',
    'box-sizing': 'border-box',
    // 'margin-left': auto;
    // 'margin-right': auto;
    'padding-left': CONTAINER_GUTTER,
    'padding-right': CONTAINER_GUTTER,
    // 'align-items': stretch;
    // 'background-color': 'rgb(255, 255, 255)',
    // border: '0'px solid black;
    // 'box-sizing': 'border-box',
    // display: 'flex',
    // flexBasis: 'auto',
    // 'flex-direction':  'column',
    // flexShrink: 0;
    // listStyle: none;
    // margin: 0px;
    // min-height: 0px;
    // min-width: 0px;
    // padding: '0'px;
    position: 'relative',
    // text-decoration: none;
    'z-index': 0,
  },
  // participantContainer: {
  //   position: 'absolute',
  //   display: 'flex',
  //   top: CONTAINER_GUTTER,
  //   right: CONTAINER_GUTTER,
  //   bottom: CONTAINER_GUTTER,
  //   left: CONTAINER_GUTTER,
  //   margin: '0 auto',
  //   alignContent: 'center',
  //   'flex-wrap': 'wrap',
  //   'justify-content': 'center',
  // },
  // drawer: {
  //   display: 'flex',
  //   width: theme.rightDrawerWidth,
  //   height: `calc(100% - ${theme.footerHeight}px)`,
  // },
  // thumbnailContainer: {
  //   display: 'flex',
  //   'flex-wrap': 'wrap',
  //   padding: '5px',
  //   'overflow-y': 'auto',
  // },
  // apNavView: {
  //   // table {
  //   'border-collapse': 'collapse',
  //   // }
  // },
  // apCalendarGrid: {
  //   height: 'auto',
  //   'border-collapse': 'collapse',
  // },
  // apCalendarRow: {
  // // tr {
  //   'border-bottom': '1pt solid rgb(203, 207, 213)',
  // // }
  // },
  // apTimeListHeader: {
  //   display: 'flex',
  //   'justify-content': 'space-between',
  //   'align-items': 'center',
  //   'font-size': '16px',
  //   'font-weight': 400,
  //   'line-height': '26px',
  //   color: theme.greyMain, // #303740
  //   // padding: '0',
  //   padding: '0 8px',
  //   'margin-bottom': '32px',
  //   // 'font-size': '13px',
  //   // 'font-weight': 500,
  //   // 'line-height': '16px',
  //   // color: '#fff',
  //   'text-transform': 'uppercase',
  // },
  // apHeadCell: {
  //   'font-family': "'Poppins', Arial, sans-serif",
  //   'font-weight': 400,
  //   'font-size': '12px',
  //   'text-align': 'center',
  //   'text-transform': 'uppercase',
  //   color: theme.grey,
  //   // .ap-cell, .ap-head-cell {
  //   // text-align: center;
  //   padding: '0',
  //   border: '0',
  //   'padding-bottom': '10px',
  //   // }
  // },
  // apCell: {
  //   width: '40px',
  //   height: '40px',
  //   color: '#333',
  //   padding: '3px', // '9px 8px',
  //   'border-radius': '8px',
  //   cursor: 'pointer',
  //   'line-height': 'normal',
  //   border: '1px solid transparent',
  //   'text-align': 'center',
  // },
  // apBtn: {
  //   position: 'relative',
  //   // margin: '0 auto',
  //   // 'border-radius': '4px',
  //   'border-radius': '50%',
  //   // 'line-height': '24px',
  //   width: '44px',
  //   height: '44px',
  //   // margin: '4px auto',
  //   // padding: '10px 8px',
  //   padding: '8px',
  //   'font-size': '14px',
  //   'font-weight': '400',
  //   'line-height': '26px',
  //   'letter-spacing': 'normal',
  //   'font-family': '"Poppins",sans-serif',
  //   border: '1px solid transparent',
  //   // "&:hover": {
  //   //   'background-color': theme.greyLight,
  //   //   border: '1px solid rgb(203, 207, 213)',
  //   // },
  // },
  // apBtn: {

  // },
  // apStateDisabled: {
  //   color: '#999',
  //   filter: 'alpha(opacity=7)',
  //   opacity: '.7',
  // },
  // apStateSelected: {
  //   background: theme.greyLight, // #F8F8F8
  //   border: '1px solid rgb(203, 207, 213)',
  // },
  // apCellOffRange: {
  //   color: '#999',
  //   // "& :hover": {
  //   //   'background-color': 'transparent',
  //   //   'border-color': 'transparent',
  //   // }
  // },
  // apTimesList: {
  //   display: 'flex',
  //   'flex-wrap': 'wrap',
  //   'padding-left': '0',
  //   listStyle: 'none',
  //   // 'flex-direction':  'column',
  //   gap: '10px',
  // },
  // apTimeSlotsTable: {

  // },
  // apTimesRow: {

  // },
  // apTimeSlot: {
  //   userSelect: 'none',
  // },
  // gutterBottom: {

  // },
  // apBtn: {

  // .rw-btn, .rw-filter-input, .rw-input, .rw-input-reset {
  //     color: inherit;
  //     padding: '0';
  //     margin: 0;
  //     border: none;
  //     box-shadow: none;
  //     background: none;
  //     background-image: none;
  //     font-family: inherit;
  //     font-size: inherit;
  //     line-height: inherit;
  //     -ms-touch-action: manipulation;
  //     touch-action: manipulation;
  // }
  // },
  // apNow: {
  //   color: theme.red,
  // },

  apCalendarHeaderButton: {
    padding: '3px 9px',
    'font-size': '13px',
    color: 'rgb(255, 255, 255)',
    'background-color': theme.red, // #E94E32
    // label: [object Object];
    border: '2px solid rgb(233, 78, 50)', // #E94E32
    // padding: 17px 14px;
    // 'background-color': 'transparent',
    // border: 1px solid rgba(0, 0, 0, 0.23);
    // padding: 5px 15px;
    // color: #ffffff;
    // padding: 19px 14px;
    // font-size: 1rem;
    'min-width': '64px',
    // 'box-sizing': 'border-box',
    transition:
      'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    'font-family': 'Poppins',
    'font-weight': 600,
    'line-height': '26px',
    'border-radius': '8px',
    // 'text-transform': 'uppercase',
    // color: inherit;
    // border: '0';
    // cursor: 'pointer',
    margin: '0',
    // display: 'inline-flex',
    outline: 0,
    // padding: '0';
    // position: 'relative',
    // 'align-items': 'center',
    // userSelect: 'none',
    // border-radius: 0;
    // 'vertical-align': 'middle',
    // mozAppearance: 'none',
    // 'justify-content': 'center',
    // 'text-decoration': 'none',
    // background-color: transparent;
    // webkitAppearance: 'none',
    // webkitTapHighlightColor: 'transparent',

    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      'background-color': 'rgba(0, 0, 0, 0.12)',
      'border-color': 'rgb(224, 224, 224)', // #e0e0e0
      // 'box-shadow': 'none',
      // color: rgba(0, 0, 0, 0.26);

      // cursor: 'default',
      // 'pointer-events': 'none',
    },
  },

  apCalendarHeaderOutlinedButton: {
    color: theme.red, // #E94E32
    'background-color': 'transparent',
  },

  timeTablePlaceholder: {
    width: '100%',
    // position: 'absolute',
    // top: 0,
    // left: '0',
    'padding-left': '6px',
    'padding-right': '6px',
    'margin-bottom': '80px',

    // "& > svg": {
    // animation: '$flash 2s ease infinite',
    // }
  },

  // apTimeSlotBtnPlaceholder: {
  //   // 'margin-bottom': -8,
  //   // 'background-color': 'rgb(248, 248, 248)',
  //   // 'border-top-left-radius': '8px',
  //   // 'border-top-right-radius': '8px',
  //   // width: '100%',
  //   // userSelect: 'none',
  //   // padding: '8px 16px',

  //   // New
  //   position: 'relative',
  //   // margin: '0 auto',
  //   // 'border-radius': '4px',
  //   'border-radius': '8px',
  //   // 'line-height': '24px',
  //   // width: '44px',
  //   height: '60px',
  //   // margin: '4px auto',
  //   // padding: '10px 8px',
  //   padding: '8px',
  //   'font-size': '12px',
  //   'font-weight': '400',
  //   'line-height': '18px',
  //   'letter-spacing': 'normal',
  //   'font-family': '"Poppins",sans-serif',
  //   border: '1px solid transparent',
  //   /* .tbk-grey-light */

  //   background: theme.greyLight,
  //   'border-radius': '8px',

  //   /* Inside auto layout */

  //   // flex: 'none',
  //   // order: 0,
  //   // 'align-self': 'stretch',
  //   'flex-grow': 1,
  //   userSelect: 'none',
  //   cursor: 'pointer',
  //   'text-align': 'center',
  //   // "&:hover": {
  //   //   'background-color': theme.greyLight,
  //   //   border: '1px solid rgb(203, 207, 213)',
  //   //   color: theme.greyMain,
  //   // },
  //   // transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
  // },

  setEveryButtonPlaceholder: {
    width: '171px',
    height: '36px',
    // cursor: 'default',
    // 'pointer-events': 'none',
    'background-color': theme.greyDisabled, // #e0e0e0
    'border-radius': '8px',
    // animation: '$flash 2s ease infinite',
  },

  buttonsDuetContainer: {
    position: 'relative',
    // width: calc(100% + 16px);
    // margin: -8px;
    width: '100%',
    display: 'grid',
    'grid-template-columns': 'repeat(2, 1fr)',
    'grid-template-rows': 'repeat(2, 1fr)',
    'grid-column-gap': '8px',
    'grid-row-gap': '24px',

    // 'grid-template-rows': '100%',
    // flex-wrap: wrap;
    // box-sizing: border-box;

    //       height: '100%',
    //       display: 'grid',
    //       'grid-template-columns': `1fr ${theme.sidebarWidth}px`,
    //       'grid-template-rows': '100%',
    //       [theme.breakpoints.down('sm')]: {
    //         'grid-template-columns': `100%`,
    //         'grid-template-rows': `calc(100% - ${totalMobileSidebarHeight}) ${totalMobileSidebarHeight}`,
    //       },
    //     },
  },
  buttonsDuet: {
    cursor: 'pointer',
    display: 'flex',
    width: '100%',
    // background: 'transparent',
    border: '0',
    // padding: '0',
    'background-color': theme.greyLight, //'#ffffff',
    padding: '16px 16px',
    'border-radius': '8px',

    '@media(hover: none)': {
      '&:hover': {
        'background-color': theme.greyLight,
      },
    },
  },

  // ctaButtonPlaceholder: {
  //   height: 48,
  //   'background-color': theme.greyLight, //'#ffffff',
  //   'margin-bottom': 8,
  //   padding: 16,
  //   'border-radius': '8px',
  //   // animation: '$flash 2s ease infinite',
  // },

  // ctaButtonPlaceholderSecondary: {
  //   height: 48,
  //   'background-color': theme.grey, //'#ffffff',
  //   padding: 16,
  //   'border-radius': '8px',
  //   // animation: '$flash 2s ease infinite',
  // },

  loaderSpinner: {
    '& > svg': {
      right: '11px',
      top: '11px',
      position: 'absolute',
      // 'pointer-events': 'none',
      animation: '$spin 1s linear infinite',
      display: 'inline-block',
      'vertical-align': 'text-bottom',
      fill: 'currentColor',
      'z-index': 2,
    },
  },

  overlay: {
    position: 'absolute',
    top: '0', // 80,
    left: '0',
    right: '0',
    bottom: '0', // 176,
    'background-color': 'rgb(255, 255, 255)',
    // 'pointer-events': 'none',
    opacity: 0.7,
    'z-index': 999,
  },

  loaderContainer: {
    position: 'absolute',
    top: '152px',
    left: '50%',
    transform: 'translateX(-50%)',
    'z-index': 1002,
  },

  '@keyframes spin': {
    '100%': {
      'webkit-transform': 'rotate(360deg)',
      transform: 'rotate(360deg)',
    },
  },

  // "@keyframes flash": {
  //   "from": {
  //     opacity: 1
  //   },
  //   "50%": {
  //     opacity: .1
  //   },
  //   "to": {
  //     opacity: 1
  //   }
  // },
});

// const VIEW_UNITS = ['month', 'year', 'decade', 'century'];
// var MONTH1    = 'month1',
//   MONTH2 = 'month2',
//   MONTH3 = 'month3';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

// function clamp(date, min, max){
//   return dates.max(dates.min(date, max), min)
// }

class AvailabilityTimePickerView extends React.Component {
  static propTypes = {
    className: PropTypes.object,
    classes: PropTypes.object.isRequired,
    style: PropTypes.object,
    isFetching: PropTypes.bool,
    isOpen: PropTypes.bool,
    isFullyOpen: PropTypes.bool,
    id: PropTypes.string,
    // label: PropTypes.string,
    // today: PropTypes.instanceOf(Date),
    disabled: PropTypes.bool,
    // selected: PropTypes.instanceOf(Date),
    focused: PropTypes.instanceOf(Date),
    region: PropTypes.string,
    date: PropTypes.instanceOf(Date),
    now: PropTypes.instanceOf(Date),
    min: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    // unit: PropTypes.oneOf(['day', ...VIEW_UNITS]),
    // viewUnit: PropTypes.oneOf(VIEW_UNITS),
    headerLabel: PropTypes.string.isRequired,
    isWeekly: PropTypes.bool.isRequired,
    // allDay: PropTypes.bool.isRequired,
    currentDate: PropTypes.instanceOf(Date),
    selectedDay: PropTypes.instanceOf(Date),
    // dayAvailability: PropTypes.arrayOf(PropTypes.object),
    times: PropTypes.arrayOf(PropTypes.object),
    timesHash: PropTypes.number,
    // onDaySelected: PropTypes.func.isRequired,
    // onChange: PropTypes.func, //.isRequired
    onConfirm: PropTypes.func.isRequired,
    // onConfirmWeekly: PropTypes.func.isRequired,
    onIsWeeklyClick: PropTypes.func.isRequired,
    // onTimeSlotsClearClick: PropTypes.func.isRequired,
    onSelectAllTimeSlots: PropTypes.func.isRequired,
    onTimeSlotSelected: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    onClose: PropTypes.func,
  };

  // month params

  // month, year, mFirstDayOfWeek, enabledDayRangeStart, enabledDayRangeEnd, selectedDay[0], selectedDay[1]

  constructor(props) {
    super(props);

    // Set up min and max dates.
    // let minDate = dates.today(); // new Date();
    // let maxDate = dates.today(); // new Date();

    // maxDate = dates.add(dates.startOf(maxDate, 'month'), 3, 'month');
    // final Calendar tempDate = Calendar.getInstance();
    // final long minDateMillis = tempDate.getTimeInMillis();
    // final long maxDateMillis = tempDate.getTimeInMillis();

    // this.handleTimeSlotSelected = this.handleTimeSlotSelected.bind(this);
    // this.selectAllTimeSlots = this.selectAllTimeSlots.bind(this);
    // this.clearAllTimeSlots = this.clearAllTimeSlots.bind(this);
    // this.handleConfirm = this.handleConfirm.bind(this);
    this.handleSetEveryWeekdayClick = this.handleSetEveryWeekdayClick.bind(this);
    // this.handleClose = this.handleClose.bind(this);

    // const timeSlots = this.populateTimeSlots();

    this.state = {
      // monthViews: [MONTH1, MONTH2, MONTH3],
      // times: [],
      // minDate,
      // maxDate,
      // timeSlots,
      // isAllDay: this.allDaySelected(timeSlots),
      timeSlotsShown: false,
      weekDay: '',
      // isWeekly: false,
    };
  }

  // getCurrentDate(): Date {
  //    return this.props.currentDate || this.props.value || new Date();
  // }

  // handleDaySelected(day: Date) {
  //   // mCurrentDate = day;
  //   // this.setState({ currentDate: day });

  //   const year = dates.year(day); // currentDate.year();

  //   // if (callbackToClient && mDateChangedListener != null) {
  //   //     mDateChangedListener.onDateChanged(this, day);
  //   // }

  //   // mDayPickerView.setDate(day, false);

  //   this.setState({ selectedDay: day });

  //   // Passthrough to the parent
  //   // onDaySelected(day);

  //   // onCurrentDateChanged(fromUser);
  // }

  handleSetEveryWeekdayClick() {
    const { isWeekly } = this.props;
    // // var start = values.min; // dates.add(values.min, timezoneOffset, 'minutes'); // Normalize min time according to the time zone
    // const selectedDay = this.props.selectedDay;
    // let start = dates.startOf(selectedDay, 'day');
    // const end = this.state.maxDate;

    // let dayAvailabilityWeekly = [];

    // while (dates.lte(start, end)) {

    //   dayAvailabilityWeekly.push({
    //     day: dateLocalizer.format(start, 'YYYY-MM-DD', this.props.culture),
    //     allDay: this.state.isAllDay,
    //     timeSlots: this.state.timeSlots.map(ts => ({
    //       startTime: ts.startTime,
    //       endTime: ts.endTime,
    //       slotType: ts.slotType
    //     })),
    //   });

    //   start = dates.add(start, 7, 'day');
    // }

    // this.setState({  });
    this.props.onIsWeeklyClick(!isWeekly);

    // this.props.onConfirmWeekly(dayAvailabilityWeekly, !this.state.isWeekly);

    // return dayAvailabilityWeekly;
  }

  onDateChanged(view /* AvailabilityDatePicker  */, selectedDate: Date) {
    // Context context = getContext();
    // We get here after seleting a date
    // mDatePicker.init(selectedDate,this);
    // mTimePicker.setCurrentDay(selectedDate);
    // mTimePickerGridView.setVisibility(View.INVISIBLE);
    // mSlidingUpPanelLayout.setPanelState(TBSlidingUpPanelLayout.PanelState.ANCHORED);
  }

  // getBounds (props) {
  //   var value = props.value || props.currentDate || dates.today(),
  //       // useDate = props.preserveDate,
  //       min = props.min,
  //       max = props.max,
  //       start,
  //       end;

  //   //compare just the time regradless of whether they fall on the same day
  //   // if (!useDate) {
  //   //     start = dates.startOf(
  //   //         dates.merge(new Date(), min, props.currentDate),
  //   //         'minutes'
  //   //     );

  //   //     end = dates.startOf(
  //   //         dates.merge(new Date(), max, props.currentDate),
  //   //         'minutes'
  //   //     );

  //   //     if (dates.lte(end, start) && dates.gt(max, min, 'day'));

  //   //     end = dates.tomorrow();

  //   //     return {
  //   //         min: start,
  //   //         max: end,
  //   //     };
  //   // }

  //   start = dates.today();
  //   end = dates.tomorrow();

  //   //date parts are equal
  //   return {
  //       min: dates.eq(value, min, 'day')
  //           ? dates.merge(start, min, props.currentDate)
  //           : start,
  //       max: dates.eq(value, max, 'day')
  //           ? dates.merge(start, max, props.currentDate)
  //           : end,
  //   };
  // }

  shouldComponentUpdate(nextProps, nextState) {
    const isTimesChanged = this.props.timesHash !== nextProps.timesHash;
    const isIsWeeklyChanged = this.props.isWeekly !== nextProps.isWeekly;
    const isTimeSlotsShownChanged = this.state.timeSlotsShown !== nextState.timeSlotsShown;
    const isIsFullyOpenChanged = this.props.isFullyOpen !== nextProps.isFullyOpen;
    const isIsOpenChanged = this.props.isOpen !== nextProps.isOpen;
    const isIsFetchingChanged = this.props.isFetching !== nextProps.isFetching;
    const isSelectedDayChanged = +this.props.selectedDay !== +nextProps.selectedDay;

    const isOnTimeSlotSelectedChanged = this.props.onTimeSlotSelected !== nextProps.onTimeSlotSelected;
    const isOnConfirmChanged = this.props.onConfirm !== nextProps.onConfirm;
    const isOnIsWeeklyClickChanged = this.props.onIsWeeklyClick !== nextProps.onIsWeeklyClick;
    const isOnSelectAllTimeSlotsChanged = this.props.onSelectAllTimeSlots !== nextProps.onSelectAllTimeSlots;
    const isOnClearChanged = this.props.onClear !== nextProps.onClear;
    const isOnCloseChanged = this.props.onClose !== nextProps.onClose;

    return (
      isIsOpenChanged ||
      isIsFullyOpenChanged ||
      (nextProps.isFullyOpen &&
        (isTimesChanged ||
          isIsFullyOpenChanged ||
          isTimeSlotsShownChanged ||
          isIsFetchingChanged ||
          isIsOpenChanged ||
          isIsWeeklyChanged ||
          isSelectedDayChanged ||
          isOnTimeSlotSelectedChanged ||
          isOnConfirmChanged ||
          isOnIsWeeklyClickChanged ||
          isOnSelectAllTimeSlotsChanged ||
          isOnClearChanged ||
          isOnCloseChanged))
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { isFullyOpen } = this.props;

    // if (!_.isShallowEqual(prevProps.dayAvailability, this.props.dayAvailability)) {

    // if (!prevProps.selectedDay && this.props.selectedDay ||
    //   prevProps.selectedDay && this.props.selectedDay && prevProps.selectedDay.getTime() !== this.props.selectedDay.getTime()) {
    //   this.setState({ timeSlots: this.populateTimeSlots() });
    // console.log('componentDidUpdate 1st');
    // }

    // if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen) {
    //   // const timeSlots = this.populateTimeSlots();

    //   this.setState({ isWeekly: false, timeSlotsShown: false });
    // }

    if (prevProps.isFullyOpen !== isFullyOpen && isFullyOpen) {
      //   const timeSlots = this.populateTimeSlots();

      this.setState({
        weekDay: dateLocalizer.format(this.props.selectedDay, 'dddd', this.props.culture),
        //     // isWeekly: false,
        //     // timeSlotsShown: true,
        //     timeSlots,
        //     times: this.getTimes(timeSlots),
        //     timesHash: Math.random(),
        //     // isAllDay: this.allDaySelected(timeSlots),
      });
    }
  }

  render() {
    const {
      // className,
      classes,
      // value, /*todaysDate, */
      // disabled,
      headerLabel,
      isFetching,
      isFullyOpen,
      isWeekly,
      selectedDay,
      times,
      onTimeSlotSelected,
      onSelectAllTimeSlots,
      onConfirm,
      onClear,
      onClose,
      // currentDate
    } = this.props;
    const { weekDay } = this.state;
    // const { /*minDate, maxDate, */times } = this.state;

    // const times = this.getTimes();

    // console.log('AvailabilityTimePickerView render');

    let rows: any = isFullyOpen ? _.chunk(times, 6) : [];

    // console.log();

    return (
      <div className={classes.container}>
        {/*<ScrollView
        // key={`${this.props.scrollEnabled}`}
        // ref={this.props.refCallback}
        // onScroll={this.props.onMomentumScrollEnd}
        style={{
          overflow: 'scroll', // this.props.scrollEnabled ? 'scroll' : 'hidden',
          width: '100%',
          // height: '100%',
          // padding: '24px 16px',
          // 'background-color': 'rgb(255, 255, 255)',
          // 'border-radius': '8px',
          // overflow: 'scroll'
        }}
      >*/}
        <div className={classes.availabilityTimePickerContainer}>
          {/*<Header
            // // isRtl={this.isRtl()}
            label={this.getHeaderLabel(index)}
            // prevLabel={this.getHeaderLabel('LEFT')}
            // nextLabel={this.getHeaderLabel('RIGHT')}
            // labelId={this.labelId}
            // messages={this.messages}
            // // upDisabled={isDisabled || view === last(views)}
            // prevDisabled={isDisabled || !dates.inRange(this.nextDate('LEFT'), min, max, view)}
            // nextDisabled={isDisabled || !dates.inRange(this.nextDate('RIGHT'), min, max, view)}
            // onViewChange={this.handleViewChange}
            // onMoveLeft ={this.handleMoveBack}
            // onMoveRight={this.handleMoveForward}
        />*/}
          {/*<div className={classes.apTimeListHeader}>*/}
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              color: 'rgb(48, 55, 64)', // #303740
              // padding: "0",
              marginBottom: '32px',
              paddingTop: 0,
              paddingRight: '8px',
              paddingLeft: '8px',
              paddingBottom: 0,
              textTransform: 'uppercase',
            }}
          >
            <span
              // id={labelId}
              // onClick={onViewChange}
              // className={classes.apCalendarBtnView}
              // disabled={upDisabled}
              aria-live="polite"
              aria-atomic="true"
            >
              <Typography variant="button">{headerLabel}</Typography>
            </span>
            {isFullyOpen ? (
              <button
                color="primary"
                variant="contained"
                size="small"
                disabled={isFetching}
                className={`${classes.apCalendarHeaderButton} ${
                  isWeekly ? null : classes.apCalendarHeaderOutlinedButton
                }`}
                // style={{ border: '1px solid #F1644A', }}
                // style={{ visibility: isFetching ? 'hidden' : '' }}
                onClick={this.handleSetEveryWeekdayClick}
              >
                {/*<Typography variant="subtitle1" className={clsx(classes.greyColor)} >{'0 DAYS / 0 HOURS'}</Typography>*/}
                Set Every {weekDay}
              </button>
            ) : (
              <div className={classes.setEveryButtonPlaceholder} />
            )}
          </View>

          {selectedDay && isFullyOpen ? (
            <table style={{ width: '100%', borderSpacing: '6px', marginBottom: '80px' }}>
              <tbody>
                {rows.map((row, index) => (
                  <tr style={{ paddingBottom: '24px' }} key={index}>
                    {row.map(v => (
                      <AvailabilityView.TimeSlot
                        // disabled={isFetching || !isFullyOpen}
                        date={v.date}
                        slotType={v.slotType}
                        onClick={onTimeSlotSelected}
                        key={v.label}
                      >
                        <>
                          <div>{v.label}</div>
                          {v.labelAmPm}
                        </>
                      </AvailabilityView.TimeSlot>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <TimeTablePlaceholder className={classes.timeTablePlaceholder} />
          )}
          {isFetching && <div className={classes.overlay}></div>}
        </div>
        {/*</ScrollView>*/}

        <View style={nativeStyles.ctaContainer}>
          {isFullyOpen ? (
            <div className={classes.buttonsDuetContainer}>
              <Button
                className={classes.buttonsDuet}
                // style={{ 'margin-bottom': 8 }}
                startIcon={<SquaresIcon />}
                onClick={onSelectAllTimeSlots}
              >
                <Typography variant="caption" color="primary">
                  Select all
                </Typography>
              </Button>

              <Button
                className={classes.buttonsDuet}
                // style={{ 'margin-bottom': 8 }}
                onClick={onClear}
                startIcon={<SquaresOIcon />}
              >
                <Typography variant="caption" color="primary">
                  Clear all
                </Typography>
              </Button>

              <Button
                disabled={isFetching}
                variant="contained"
                /*className={classes.buttonsDuet}*/
                size="medium"
                fullWidth
                style={{ padding: '11px 14px' }}
                startIcon={<CloseIcon />}
                onClick={onClose}
              >
                <Typography variant="button">Cancel</Typography>
              </Button>

              <Button
                disabled={isFetching}
                variant="contained"
                /*className={classes.buttonsDuet}*/
                color="primary"
                size="medium"
                fullWidth
                style={{ padding: '11px 14px' }}
                startIcon={<CheckBoxIcon />}
                onClick={onConfirm}
              >
                <Typography variant="button">Apply</Typography>
                {isFetching && (
                  <Box
                    display="flex"
                    className={`${classes.loaderSpinner} ${classes.redColor}`}
                    sx={{
                      marginRight: '4px',
                    }}
                  >
                    <LoaderSpinnerIcon />
                  </Box>
                )}
              </Button>
            </div>
          ) : (
            <>
              <div />
              {/*<Grid container spacing={2}>
          <Grid item xs={6}>
            <div className={classes.ctaButtonPlaceholder} />
          </Grid>

          <Grid item xs={6}>
            <div className={classes.ctaButtonPlaceholder} />
          </Grid>

          <Grid item xs={6}>
            <div className={classes.ctaButtonPlaceholderSecondary} />
          </Grid>

          <Grid item xs={6}>
            <div className={classes.ctaButtonPlaceholderSecondary} />
          </Grid>
        </Grid>*/}
            </>
          )}
        </View>
        {isFetching && (
          <>
            <div className={classes.loaderContainer}>
              <Lottie options={defaultOptions} height={128} width={128} />
            </div>
          </>
        )}
      </div>
    );
  }

  handleChange(date: Date) {
    return null;
  }

  // handleClose() {
  //   const { onClose } = this.props;

  //   onClose();
  // }

  // handleConfirm() {
  //   const { onConfirm } = this.props;

  //   onConfirm(/*, this.state.isWeekly*/);
  // }
}

// class AvailabilityViewCell extends React.Component {
//   static propTypes = {
//     classes: PropTypes.object.isRequired,
//     style: PropTypes.object,
//     id: PropTypes.string,
//     label: PropTypes.string,
//     today: PropTypes.instanceOf(Date),
//     disabled: PropTypes.bool,
//     selected: PropTypes.instanceOf(Date),
//     focused: PropTypes.instanceOf(Date),
//     date: PropTypes.instanceOf(Date),
//     now: PropTypes.instanceOf(Date),
//     min: PropTypes.instanceOf(Date),
//     max: PropTypes.instanceOf(Date),
//     unit: PropTypes.oneOf(['day', ...VIEW_UNITS]),
//     viewUnit: PropTypes.oneOf(VIEW_UNITS),
//     onChange: PropTypes.func, //.isRequired
//   };

//   isEqual(date) {
//     return dates.eq(this.props.date, date, this.props.unit)
//   }

//   isEmpty() {
//     let { unit, min, max, date } = this.props;
//     return !dates.inRange(date, min, max, unit)
//   }

//   isNow() {
//     return this.isEqual(this.props.now)
//   }

//   isFocused() {
//     return this.isEqual(this.props.focused)
//   }

//   isSelected() {
//     return this.isEqual(this.props.selected)
//   }

//   isOffView() {
//     let { viewUnit, focused, date } = this.props;
//     return viewUnit && dates[viewUnit](date) !== dates[viewUnit](focused);
//   }

//   handleChange = () => {
//     let { onChange, min, max, date } = this.props;
//     onChange(clamp(date, min, max));
//   }

//   render()  {
//     let { children, id, label, disabled } = this.props;

//     // if (this.isEmpty()) {
//     //   return <td className='ap-empty-cell' role='presentation'>&nbsp;</td>
//     // }

//     return (
//       <td
//         role='gridcell'
//         id={id}
//         title={label}
//         aria-label={label}
//         aria-readonly={disabled}
//         aria-selected={this.isSelected()}
//         className={clsx(
//             'ap-grid-cell',
//             // this.props.className,
//             this.props.classes.apCell,
//             this.isOffView() && this.props.classes.apCellOffRange, //'ap-off-range',
//             this.isFocused() && this.props.classes.apStateFocused, //'ap-state-focus',
//             this.isSelected() && this.props.classes.apStateSelected, // && this.props.classes.apStateDisabled, //'ap-state-selected',
//             this.isEmpty() && 'ap-empty-cell'
//           )}
//         style={this.props.style}
//       >
//         <div
//           aria-labelledby={id}
//           onClick={this.handleChange}
//           className={clsx(
//             'ap-btn',
//             this.props.classes.apBtn,
//             this.isSelected() && this.props.classes.apStateSelected,
//             this.isNow() && this.props.classes.apNow //'ap-now'
//           )}
//         >
//           {children}
//         </div>
//       </td>
//     )
//   }
// }

// AvailabilityView.Row = props => <tr role='row' {...props} />;
// AvailabilityView.Cell = withStyles(styles)(AvailabilityViewCell);

const nativeStyles = StyleSheet.create({
  ctaContainer: {
    right: '0',
    left: '0',
    position: 'absolute',
    bottom: '0',
    padding: '16px',
    'background-color': 'rgb(255, 255, 255)',
  },
});

export default withStyles(styles)(AvailabilityTimePickerView); //CalendarView;
